import { get, isEmpty } from 'lodash';
import { createSelector } from 'reselect';

export const getControlPin = state => get(state, 'cvControlPin');

export const getPayload = createSelector(
  [getControlPin],
  setControlPin => get(setControlPin, 'payload', false),
);

export const getLoading = createSelector(
  [getControlPin],
  setControlPin => get(setControlPin, 'loading', false),
);

export const getError = createSelector(
  [getControlPin],
  setControlPin => get(setControlPin, 'error', false),
);

export const getInitial = createSelector(
  [getControlPin],
  setControlPin => get(setControlPin, 'initial', false),
);

export const getIsSuccess = createSelector(
  [getPayload],
  payload => !isEmpty(payload),
);

export const getPinPurchaseStatus = createSelector(
  [getInitial],
  initial => get(initial, ['pin_purchase', 'status']),
);

export const getPinParentalStatus = createSelector(
  [getInitial],
  initial => get(initial, ['pin_parental', 'status']),
);

export const getPinParentalInfo = createSelector(
  [getInitial],
  initial => get(initial, ['pin_parental', 'info']),
);

export const getPinChannelStatus = createSelector(
  [getInitial],
  initial => get(initial, ['pin_channel', 'status']),
);

export const getStatusIsActive = createSelector(
  [getPinPurchaseStatus, getPinParentalStatus, getPinChannelStatus],
  (pinPurchase, pinParental, pinChannel) =>
    !!+pinPurchase || !!+pinParental || !!+pinChannel,
);

export const getStatusPinValues = createSelector(
  [
    getPinPurchaseStatus,
    getPinParentalStatus,
    getPinChannelStatus,
    getPinParentalInfo,
  ],
  (pinPurchase, pinParental, pinChannel, pinParentalInfo) => ({
    pinPurchase,
    pinParental,
    pinParentalInfo,
    pinChannel,
  }),
);

export const getControlPinError = createSelector(
  [getError],
  error => {
    if (error)
      return {
        code: get(error, 'code', false),
        message:
          error.error.length > 0
            ? get(error, 'error.0', false)
            : get(error, 'error', false),
      };
    return error;
  },
);
